import { render, staticRenderFns } from "./dialogTrusteeship.vue?vue&type=template&id=59c94cbd&"
import script from "./dialogTrusteeship.vue?vue&type=script&lang=js&"
export * from "./dialogTrusteeship.vue?vue&type=script&lang=js&"
import style0 from "./dialogTrusteeship.vue?vue&type=style&index=0&id=59c94cbd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports